﻿import Chart from 'chart.js/auto'

export function initPollChart() {
    $(".poll-result").each(function () {
        const canvas = $(this);
        const url = canvas.data("url");
        $.get(url, function (data) {
            const config = {
                options: {
                    responsive: true,

                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 0,
                                max: 100,
                                stepSize: 10
                            }
                        }]
                    },
                },
                animation: false,
                scaleLabel: "<%=value/1%>%",
                type: 'bar',
                data
            };
            const htmlElement = canvas.get(0);
            const ctx = htmlElement.getContext("2d");
            const myLine = new Chart(ctx, config)
        });
    });
}
